import axios from 'axios';
import { getApiBaseUrl } from '../config/api';

const API_BASE_URL = getApiBaseUrl();

const websiteGeneratorApi = axios.create({
  baseURL: `${API_BASE_URL}/website-generator`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
websiteGeneratorApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors
websiteGeneratorApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear invalid token and user data
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Only redirect if not already on login page
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const websiteGeneratorService = {
  // Generate website for specific website ID
  generateWebsite: async (websiteId: string, generationOptions?: any) => {
    const response = await websiteGeneratorApi.post(`/generate/${websiteId}`, generationOptions);
    return response.data;
  },

  // Generate NGINX configuration for specific website ID
  generateNginxConfig: async (websiteId: string) => {
    const response = await websiteGeneratorApi.post(`/generate-nginx/${websiteId}`);
    return response.data;
  },

  // Delete website files
  deleteWebsiteFiles: async (websiteId: string) => {
    const response = await websiteGeneratorApi.delete(`/delete/${websiteId}`);
    return response.data;
  },

  // Get website generation status
  getGenerationStatus: async (websiteId: string) => {
    const response = await websiteGeneratorApi.get(`/status/${websiteId}`);
    return response.data;
  },

  // Get list of generated websites
  getGeneratedWebsites: async () => {
    const response = await websiteGeneratorApi.get('/generated-websites');
    return response.data;
  },
};

export default websiteGeneratorApi;
